import React, { useState } from 'react';
import './App.css';
import BusinessAnalysisForm from './components/BusinessAnalysisForm';
import AnalysisResults from './components/AnalysisResults';
import PromptSettings from './components/PromptSettings';
import { AnalysisResponse } from './types';

function App() {
  const [results, setResults] = useState<AnalysisResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [showPromptSettings, setShowPromptSettings] = useState(false);

  const handleAnalysisComplete = (data: AnalysisResponse) => {
    setResults(data);
  };

  const handleNewAnalysis = () => {
    setResults(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <div>
            <h1>TrendRisq</h1>
            <p>Business Risk & Trend Analysis</p>
          </div>
          <button
            className="settings-button"
            onClick={() => setShowPromptSettings(true)}
            title="Configure System Prompts"
          >
            ⚙️ Prompt Settings
          </button>
        </div>
      </header>
      
      <main className="App-main">
        {!results ? (
          <BusinessAnalysisForm 
            onAnalysisComplete={handleAnalysisComplete}
            loading={loading}
            setLoading={setLoading}
          />
        ) : (
          <AnalysisResults 
            results={results}
            onNewAnalysis={handleNewAnalysis}
          />
        )}
      </main>

      {showPromptSettings && (
        <PromptSettings onClose={() => setShowPromptSettings(false)} />
      )}
    </div>
  );
}

export default App;

